import {
  ICON_HEIGHT_12,
  ICON_HEIGHT_16,
  ICON_HEIGHT_20,
  ICON_HEIGHT_24,
  ICON_HEIGHT_28,
  ICON_HEIGHT_32,
  ICON_HEIGHT_36,
  ICON_HEIGHT_40,
  ICON_HEIGHT_44,
  ICON_HEIGHT_64,
  ICON_HEIGHT_100,
} from '../../Icon'
import { FileIconType } from '../FileIcon.constants'

export const FILE_ICON_PLACEHOLDER_SIZE = {
  [ICON_HEIGHT_16]: ICON_HEIGHT_12,
  [ICON_HEIGHT_24]: ICON_HEIGHT_20,
  [ICON_HEIGHT_32]: ICON_HEIGHT_24,
  [ICON_HEIGHT_40]: ICON_HEIGHT_28,
  [ICON_HEIGHT_44]: ICON_HEIGHT_32,
  [ICON_HEIGHT_64]: ICON_HEIGHT_36,
  [ICON_HEIGHT_100]: ICON_HEIGHT_40,
}

export const FILE_ICON_PLACEHOLDER_BACKGROUND_COLOR = {
  [FileIconType.Play]: 'var(--color-white)',
}

export const FILE_ICON_PLACEHOLDER_OPACITY = {
  [FileIconType.Play]: '32%',
  colored: '10%',
  default: '16%',
}
